import type { RouteRecordRaw } from "vue-router"

export const OfferLookupResumeRoutes: RouteRecordRaw[] = [
  {
    path: "offer-lookup-resume",
    children: [
      {
        path: "",
        component: () => import("./OfferLookupResumePage.vue"),
      },
    ],
  },
]
